var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from "react";
import styled, { css } from "styled-components";
import ErrorLabel from "./ErrorLabel";
import _ from "lodash";
const StyledInputItem = styled.div `
  position: relative;
  display: block;

  &:last-child {
    margin-bottom: 0;
  }

  &:focus-within {
    border-color: ${props => props.theme.name === 'invoned' ? "none" : props.theme.borderHover};

    .focus-border {
      transform: scaleX(1);
    }
  }

  ${props => props.variant === "money-input" &&
    css `
      &:after {
        content: "€";
        display: block;
        position: absolute;
        bottom: 11px;
        left: 0;
        color: ${props => props.theme.tertiary};
      }
    `};
`;
const StyledInput = styled.input `
  transition: border-color 0.2s ease-in-out;
  padding: ${props => props.icon ? "20px 10px 20px 45px" : "20px 10px"};
  background-color: transparent;
  border: 1px solid ${props => props.theme.border};
  width: 100%;
  box-sizing: border-box;
  outline: none;
  font-size: 16px;
  line-height: 1.2rem;
  color: ${props => props.theme.tertiary};
  border-radius: 8px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  ${props => props.theme.name === 'invoned' &&
    css `
      border: none;
      border-bottom: 1px solid ${props => props.theme.border};
      border-radius: 0;
    `}

  @media only screen and (min-width: 540px) {
    padding: ${props => props.icon ? "18px 20px 18px 45px" : "18px 20px"};
  }

  &:disabled {
    background-color: #eeeeee;
    cursor: default;

    + label {
      opacity: 0.5;
    }
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &[type=number] {
    -moz-appearance: textfield;
  }

  ${props => props.variant === "money-input" &&
    css `
      padding-left: 15px;

      &:placeholder-shown:not(:focus) + label {
        position: absolute;
        top: 0;
        left: 0;
        transform: none;
        pointer-events: none;
        color: ${props => props.theme.tertiary};
        font-weight: 600;
        font-family: ${props => props.theme.fontBase};
        font-size: 85%;
      }
    `};
`;
const IconWrapper = styled.div `
  position: absolute;
  top: 49px;
  left: 15px;

  @media only screen and (min-width: 768px) {
    top: 46px;
  }
  
  svg {
    stroke: ${props => props.theme.tertiary};
  }
`;
const StyledLabel = styled.label `
  display: block;
  color: ${props => props.theme.textDark};
  font-weight: 400;
  transition: all 0.2s;
  font-size: 14px;
  margin-bottom: 10px;
`;
const StyledOuterWrapper = styled.div `
  margin-bottom: 35px;

  &:last-child {
    margin-bottom: 0;
  }
`;
export const FocusBorder = styled.span `
    position: absolute;
    bottom: 0;
    left: 0;
    transform-origin: 0;
    transform: scaleX(0);
    width: 100%;
    height: 1px;
    background-color: ${props => props.theme.secondary};
    transition: all 300ms ease-in-out;
    border-radius: 1px;
`;
const CleanInputItem = (_a) => {
    var { className, icon, label, placeholder, floatingLabel, error, variant, formatCents } = _a, props = __rest(_a, ["className", "icon", "label", "placeholder", "floatingLabel", "error", "variant", "formatCents"]);
    const [customError, setError] = useState(error);
    const [fid] = useState(props.id || _.uniqueId("field-"));
    if (variant && formatCents) {
        props.inputMode = props.inputMode || "decimal";
        props.step = props.step || 0.01;
        props.min = props.min || 0;
        props.onKeyDown = (e) => {
            if (e.key.match(/([\d,.]|.{2,})/) || e.metaKey) {
                return;
            }
            e.preventDefault();
        };
        props.onInput = function (e) {
            if (!(e.currentTarget.value + "").match(/^(\d+([,.]\d{0,2})?)?$/)) {
                setError("Bedrag moet bijvoorbeeld 50,41 zijn");
            }
            else {
                setError(false);
            }
        };
        props.onBlur = e => {
            if (!(e.currentTarget.value + "").match(/^(\d+([,.]\d{2})?)?$/)) {
                setError("Bedrag moet bijvoorbeeld 50,41 zijn");
            }
            else {
                setError(false);
            }
        };
    }
    useEffect(() => {
        if (props.readOnly || props.disabled || error) {
            setError(error);
        }
    }, [props.readOnly, props.disabled, error]);
    return (React.createElement(StyledOuterWrapper, null,
        React.createElement(StyledInputItem, { className: className, icon: icon, variant: variant },
            React.createElement(StyledLabel, { className: "input-item__input", htmlFor: fid, error: !!customError }, label),
            React.createElement(StyledInput, Object.assign({}, props, { placeholder: " ", floatingLabel: floatingLabel, icon: icon, variant: variant, id: fid, className: "input-item__icon-wrapper" })),
            React.createElement(IconWrapper, null, icon),
            React.createElement(FocusBorder, { className: "focus-border" })),
        !!customError && React.createElement(ErrorLabel, null, customError)));
};
export default CleanInputItem;
